import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="android" api="clear-updated-configuration" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void clearUpdatedConfiguration();
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`MobileCore.clearUpdatedConfiguration();
`}</code></pre>
    <Variant platform="android" api="configure-with-app-id" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-1"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void configureWithAppID(final String appId);
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`MobileCore.configureWithAppId("1423ae38-8385-8963-8693-28375403491d");
`}</code></pre>
    <Variant platform="ios" api="configure-with-app-id" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func configure(withAppId: String)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`ACPCore.configure(withAppId: "1423ae38-8385-8963-8693-28375403491d")
`}</code></pre>
    <h4 {...{
      "id": "objective-c"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void) configureWithAppId: (NSString* __nullable) appid;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[ACPCore configureWithAppId:@"1423ae38-8385-8963-8693-28375403491d"];
`}</code></pre>
    <Variant platform="unity" api="configure-with-app-id" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "c"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public static void ConfigureWithAppID(string appId)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPCore.ConfigureWithAppID("1423ae38-8385-8963-8693-28375403491d");
`}</code></pre>
    <Variant platform="xamarin" api="configure-with-app-id" repeat="7" mdxType="Variant" />
    <h4 {...{
      "id": "c-1"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`Android syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public unsafe static void ConfigureWithAppID (string appId);
`}</code></pre>
    <p><strong parentName="p">{`iOS syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public static void ConfigureWithAppID (string appid);
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPCore.ConfigureWithAppID("1423ae38-8385-8963-8693-28375403491d");
`}</code></pre>
    <Variant platform="android" api="configure-with-file-in-assets" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-2"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void configureWithFileInAssets(final String fileName);
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`MobileCore.configureWithFileInAssets("exampleJSONfile.json");
`}</code></pre>
    <Variant platform="android" api="configure-with-file-in-path" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-3"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void configureWithFileInPath(final String filePath);
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`MobileCore.configureWithFileInPath("absolute/path/to/exampleJSONfile.json");
`}</code></pre>
    <Variant platform="ios" api="configure-with-file-in-path" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-1"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func configureWithFile(inPath: String)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let filePath = Bundle.main.path(forResource: "ExampleJSONFile", ofType: "json")
ACPCore.configureWithFile(inPath: filePath)
`}</code></pre>
    <h4 {...{
      "id": "objective-c-1"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void) configureWithFileInPath: (NSString* __nullable) filepath;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`NSString *filePath = [[NSBundle mainBundle] pathForResource:@"ExampleJSONFile"ofType:@"json"];
[ACPCore configureWithFileInPath:filePath];
`}</code></pre>
    <Variant platform="xamarin" api="configure-with-file-in-path" repeat="7" mdxType="Variant" />
    <h4 {...{
      "id": "c-2"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`Android syntax`}</strong>{` `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public unsafe static void ConfigureWithFileInPath (string filepath);
`}</code></pre>
    <p><strong parentName="p">{`iOS syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public static void ConfigureWithFileInPath (string filepath);
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPCore.ConfigureWithFileInPath("absolute/path/to/exampleJSONfile.json");
`}</code></pre>
    <Variant platform="android" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "java-4"
    }}>{`Java`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`String coreExtensionVersion = MobileCore.extensionVersion();
`}</code></pre>
    <Variant platform="ios" api="extension-version" repeat="4" mdxType="Variant" />
    <h4 {...{
      "id": "swift-2"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let coreExtensionVersion  = ACPCore.extensionVersion()
`}</code></pre>
    <h4 {...{
      "id": "objective-c-2"
    }}>{`Objective-C`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`NSString *coreExtensionVersion = [ACPCore extensionVersion];
`}</code></pre>
    <Variant platform="react-native" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "javascript"
    }}>{`JavaScript`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPCore.extensionVersion().then(coreExtensionVersion => console.log("AdobeExperienceSDK: ACPCore version: " + coreExtensionVersion));
`}</code></pre>
    <Variant platform="flutter" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "dart"
    }}>{`Dart`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`String coreExtensionVersion = await FlutterACPCore.extensionVersion;
`}</code></pre>
    <Variant platform="cordova" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "cordova"
    }}>{`Cordova`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPCore.extensionVersion(function(version) {  
   console.log("ACPCore version: " + version);
}, function(error) {  
   console.log(error);  
});
`}</code></pre>
    <Variant platform="unity" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "c-3"
    }}>{`C#`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`string coreExtensionVersion = ACPCore.ExtensionVersion();
`}</code></pre>
    <Variant platform="xamarin" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "c-4"
    }}>{`C#`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`string coreExtensionVersion = ACPCore.ExtensionVersion();
`}</code></pre>
    <Variant platform="android" api="update-configuration" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-5"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void updateConfiguration(final Map configMap);
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`HashMap<String, Object> data = new HashMap<String, Object>();
data.put("global.privacy", "optedout");
MobileCore.updateConfiguration(data);
`}</code></pre>
    <Variant platform="ios" api="update-configuration" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-3"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func updateConfiguration(_: [String: Any])
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let updatedConfig = ["global.privacy":"optedout"]
ACPCore.updateConfiguration(updatedConfig)
`}</code></pre>
    <h4 {...{
      "id": "objective-c-3"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void) updateConfiguration: (NSDictionary* __nullable) config;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`NSDictionary *updatedConfig = @{@"global.privacy":@"optedout"};
[ACPCore updateConfiguration:updatedConfig];
`}</code></pre>
    <Variant platform="react-native" api="update-configuration" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "javascript-1"
    }}>{`JavaScript`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`updateConfiguration(configMap?: { string: any })
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPCore.updateConfiguration({"global.privacy":"optedout"});
`}</code></pre>
    <Variant platform="flutter" api="update-configuration" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "dart-1"
    }}>{`Dart`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`static Future<void> updateConfiguration(Map<String, Object> configMap);
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`FlutterACPCore.updateConfiguration({"global.privacy":"optedout"});
`}</code></pre>
    <Variant platform="cordova" api="update-configuration" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "javascript-2"
    }}>{`Javascript`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`ACPCore.updateConfiguration({"newConfigKey":"newConfigValue"}, successCallback, errorCallback);
`}</code></pre>
    <Variant platform="unity" api="update-configuration" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "c-5"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public static void UpdateConfiguration(Dictionary<string, object> config);
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`var dict = new Dictionary<string, object>();
dict.Add("newConfigKey", "newConfigValue");
ACPCore.UpdateConfiguration(dict);
`}</code></pre>
    <Variant platform="xamarin" api="update-configuration" repeat="7" mdxType="Variant" />
    <h4 {...{
      "id": "c-6"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`void UpdateConfiguration([NullAllowed] NSDictionary config);
`}</code></pre>
    <p><strong parentName="p">{`iOS example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{` var config = new NSMutableDictionary<NSString, NSObject>
 {
   ["newConfigKey"] = new NSString("newConfigValue")
 };
ACPCore.UpdateConfiguration(config);
`}</code></pre>
    <p><strong parentName="p">{`Android example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`var config = new Dictionary<string, Java.Lang.Object>();
config.Add("newConfigKey", "newConfigValue");
ACPCore.UpdateConfiguration(config);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      